<template lang="pug">
  include ./../../vuek/mixins.pug

  +b.t-lng(
    @click="handleClick"
  ) {{lng === 'ua' ? 'eng' : 'укр'}}
</template>

<script>
import { mapGetters } from 'vuex';


export default {
  name: 't-lng',

  computed: {
    ...mapGetters({
      lng: 'lng',
    }),
  },

  methods: {
    handleClick() {
      this.$store.commit('CHANGE_LNG');
    },
  },
};
</script>

<style lang="scss">
@import '../../scss/styles';

.t-lng {
  $size: 30px;

  cursor: pointer;
  width: $size;
  height: $size;
  border-radius: $size / 2;
  background-color: white;
  color: $color-blue;
  line-height: $size;
  font-weight: 800;
  font-size: 10px;
  text-align: center;
  transition: all 0.3s;

  &:hover {
    transform: scale(0.9);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TLng/TLng.vue